export default (lang, { name, params, query, hash }) => {
  const adjustedName = name.replace(/-\w\w$/, '')
  return { name: `${adjustedName}-${lang}`, params, query, hash }
}
